export class PaginatedEvent {
	private page: number = 1;
	private page_size: number = 50;
	private type: string[] = ["all"];
	private sort_by: string = "";
	private sort: string = ""; // v1/prices/assets uses this property instead of `sort_by`
	private sort_dir: string = "";
	private q: string = "";
	private tag: number[] = [];

	public getPage(): number {
		return this.page;
	}

	public setPage(n: number): void {
		this.page = n;
	}

	public setPageSize(n: number): void {
		this.page_size = n;
	}

	public getType(): string[] {
		return this.type;
	}

	public setType(s: string[]): void {
		this.type = s;
	}

	public getSortBy(): string {
		return this.sort_by;
	}

	public setSortBy(s: string): void {
		this.sort_by = s;
	}

	public setSort(s: string): void {
		this.sort = s;
	}

	public setSortDirection(s: string): void {
		this.sort_dir = s;
	}

	public setSearchQuery(s: string): void {
		this.q = s;
	}

	public getNextPageRequired(): boolean {
		return this.page > 1;
	}

	public setTags(tags: number[]): void {
		this.tag = tags;
	}
}
